import { useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { useAppSelector, useAppDispatch } from '../../app/hooks';
import { selectPartyEvents, loadPartyEventsAsync, removeEventAsync, setPartyEventsFilter, selectPartyEventsFilter, selectFilteredPartyEvents, selectDisplayFilter, setDisplayFilter, selectRefreshRequired, setSortDescending, selectSortDecending } from './partyEventsSlice';
import { useAuth0 } from "@auth0/auth0-react";
import styles from './PartyEvents.module.css';
import { authSettings, callbackUri } from '../../AppSettings';
import { useMenuPanel } from '../../MenuPanelContext'
import { associatePartyEvent, setLogoutRequested } from '../currentPartyEvent/currentPartyEventSlice'
import { Page } from '../../Page'
import { resetButtons, setAddPartyEventVisible, setInformationButtonVisible, setNotificationsButtonVisible, setReloadButtonVisible } from '../menu/menuSlice'
import { transmissionDateToDisplayableDateTime } from '../../utils/dateUtils';
import { selectInvitationReference, acceptInvitationAsync} from '../invitation/invitationSlice'
import { NotLoggedInScreen } from './NotLoggedInScreen';
import { selectPartyEventsCount } from './partyEventsSlice'
import { sanitizeEmail } from '../../utils/emailUtils';
import { DownIcon, SearchIcon, UpIcon } from '../../images/Icons';
import { NotificationsButton } from '../notifications/notificationsButton';
import { ReloadButton } from '../menu/ReloadPartyEventsButton';
import { InformationButton } from '../compliance/InformationButton';
import { DropDownButton } from '../../components/DropDownButton';
import userImg from '../../images/user.svg'
import { Browser } from '@capacitor/browser';
import { AddPartyEventButton } from './AddPartyEventButton';
import { BackButton } from '../menu/BackButton';



export function PartyEvents() {
    const { user, isAuthenticated, getAccessTokenSilently, logout } = useAuth0()
    const invitationReference = useAppSelector(selectInvitationReference);
    const partyEvents = useAppSelector(selectPartyEvents)
    const partyEventsCount = useAppSelector(selectPartyEventsCount)
    const dispatch = useAppDispatch()
    const partyEventsFilter = useAppSelector(selectPartyEventsFilter)
    const filteredPartyEvents = useAppSelector(selectFilteredPartyEvents)
    const displayFilter = useAppSelector(selectDisplayFilter)
    const refreshRequired = useAppSelector(selectRefreshRequired)
    const sortDescending = useAppSelector(selectSortDecending)
    const navigate = useNavigate()
    const menuPanelRef = useMenuPanel()
    useEffect(() => {
        dispatch(resetButtons())
        dispatch(setAddPartyEventVisible(true))
        dispatch(setNotificationsButtonVisible(true))
        dispatch(setInformationButtonVisible(true))
        dispatch(setReloadButtonVisible(true))
    }, [dispatch])

    const doLogout = async () => {
        dispatch(setLogoutRequested(true))
        await logout({
          async openUrl(url) {
            await Browser.open({
              url,
              windowName: "_self",
            });
          },
          logoutParams: {
            returnTo: callbackUri
          }
        });
      };

    useEffect(() => {
        const getUserMetadata = async () => {
          if (isAuthenticated) {  
            try {
                const accessToken = await getAccessTokenSilently({ authorizationParams : {
                   
                }})
                if (user?.email) {
                    if (invitationReference != null && invitationReference.length > 0 && /\S/.test(invitationReference)) {
                        dispatch(acceptInvitationAsync({
                                    email: sanitizeEmail(user?.email),
                                    token: accessToken
                        }))
                    }
                    if (refreshRequired) {
                        dispatch(loadPartyEventsAsync({ 
                                        email: sanitizeEmail(user?.email),
                                        token: accessToken
                                    }))
                            }
                }
            } catch (error)  {
                alert(error)
            }
          }
        };
        
        getUserMetadata();
       
        
      }, [dispatch, getAccessTokenSilently, isAuthenticated, menuPanelRef, navigate, user?.email, invitationReference, refreshRequired]);
    return (
        <Page>
            {!isAuthenticated ? <NotLoggedInScreen/> : null }
            {isAuthenticated ? 
            <>
            <div className={styles.bannerContainer}>
                <div>
                <h2>PartyPlanner.</h2>
                <h4>Organise, invite and celebrate in style.</h4>
                </div>
                <div className={styles.bannerButton}>
                    <button className={styles.addPartyEventButton} onClick={()=> {
                        dispatch(associatePartyEvent({
                            id: 0 - partyEventsCount,
                            title: '',
                            location: '',
                            reference: '',
                            start: new Date().toISOString(),
                            end: new Date().toISOString(),
                            userOkToDelete: true
                        }))
                        navigate('/Welcome')
                    }}>Add Party</button>
                </div>
            </div>
             <div className={styles.titleContainer}>
             <br></br>

                <div className={styles.searchContainer}>
                <div className={styles.filterContainer}>
                    <input
                        autoFocus
                        size={60}
                        type= 'text'
                        className={styles.searchFilter}
                        value={partyEventsFilter}
                        placeholder='Search by name or location'
                        onChange={(e) => {
                            dispatch(setPartyEventsFilter(e.target.value))
                        }}>
                    </input>
                </div> 
                <div className={styles.widget}> 
                        <NotificationsButton/>
                        <ReloadButton/>
                        <InformationButton/>
                        <DropDownButton imgSrc={userImg} imgAlt="User Menu">
                        <div className={styles.linkButton} onClick={doLogout}>Sign out</div>
                        <div className={styles.linkButton} onClick={()=> {navigate('/Merchandise')}}>Merchandise</div>
                        <div className={styles.linkButton} onClick={() => {navigate('/AccountDetails')}}>Account details</div>
                        </DropDownButton>
                </div>
                </div>

                </div> 
                                {/* <div className={styles.arrowContainer}>
                { sortDescending ? 
                <div className={styles.UpButton} onClick={() => {
                    dispatch(setSortDescending(false))}}>
                    <UpIcon/>
                </div>
                : 
                <div className={styles.DownButton} onClick = {()=> {
                    dispatch(setSortDescending(true)) }}>
                     <DownIcon/>
                    </div>
                }
                </div> */}
                </>
                 : null }
                 
            {
                isAuthenticated && filteredPartyEvents?.map((partyEvent) => 
                        
                        <div className={styles.eventContainer} key={partyEvent.id} onClick={() => {
                            dispatch(associatePartyEvent(partyEvent))
                            navigate('/currentPartyEvent')
                        }}>
                        <div className={styles.eventInfoPanel}>
                            <h3>{partyEvent.title}</h3>
                            <h4 className={styles.eventlocation}>{partyEvent.location}</h4>
                            <h5>{partyEvent.start ? transmissionDateToDisplayableDateTime(partyEvent.start) : "No date"}</h5>
                        </div>

                            { partyEvent.userOkToDelete?
                            <button className={styles.deleteParty} onClick={async (e) => {
                                e.stopPropagation()
                                if (isAuthenticated) {  
                                    try {
                                        const accessToken = await getAccessTokenSilently({ authorizationParams : {
                                        }})
                                        if (user?.email) {
                                            dispatch(removeEventAsync({ 
                                                partyEventId: partyEvent.id,
                                                userEmail: sanitizeEmail(user?.email),
                                                token: accessToken
                                            }))
                                        }
                                    } catch (error)  {
                                    }
                                  }
                                
                            }}
                            >Delete</button>
                   : null     }
                        </div>       
                )       
            }
            {/* { isAuthenticated ?
            <>
            <div className={styles.addPartyEventButton} onClick={()=> {
                dispatch(associatePartyEvent({
                    id: 0 - partyEventsCount,
                    title: '',
                    location: '',
                    reference: '',
                    start: new Date().toISOString(),
                    end: new Date().toISOString(),
                    userOkToDelete: true
                }))
                navigate('/Welcome')
            }}><p> Add Party Event</p></div>
            <br></br>
            <br></br>
            <br></br>
            </>
        : null } */}
        </Page>
    )
}
